import { CheckIcon } from "lucide-react";
import { Card, CardContent } from "@/pages/newHome/ui/card";

export const StatsByAnima = (): JSX.Element => {
  const statistics = [
    {
      value: "75%",
      description: "of the sales process handled by our system",
    },
    {
      value: "12x",
      description: "increase in lead flow for the sales team",
    },
    {
      value: "300+",
      description: "hours saved per year per sales rep",
    },
  ];

  const targetAudience = [
    "Trades Contractors",
    "Building Material Suppliers",
    "Realtors",
    "Construction Professionals",
  ];

  return (
    <section className="xl:min-h-[95vh] px-10 flex flex-col md:flex-row lg:flex-row xl:flex-row items-center justify-center gap-8 lg:gap-[70px] xl:px-0 py-12 xl:py-20 w-full bg-white mx-auto">
      {/* Statistics Section */}
      <div className="w-full xl:w-[526px]">
        <h2 className="font-medium text-charcoal text-left text-[24px] md:text-2xl lg:text-[28px] leading-[29.3px] xl:leading-[1.5] mb-5 lg:mb-6">
          On Average, BuildMapper users report
        </h2>

        <div className="grid grid-cols-2 gap-4 lg:gap-5 w-full">
          {statistics.slice(0, 2).map((stat, index) => (
            <Card 
              key={index} 
              className="bg-[#F5F5F5] border-none w-full h-[140px] lg:h-[160px] xl:h-[171px] min-h-[140px]"
            >
              <CardContent className="p-4 sm:p-4 lg:p-[25px] h-full">
                <div className="relative h-full flex flex-col gap-2 sm:gap-4">
                  <div className="font-bold text-left text-primary text-[32px] lg:text-[42px] xl:text-[50px] leading-none whitespace-nowrap">
                    {stat.value}
                  </div>
                  <div className="sm:mt-auto sm:pt-2 xl:pt-0">
                    <div className="font-normal text-left text-charcoal text-[16px] lg:text-base xl:text-xl leading-[1.5] max-w-[200px] lg:max-w-[220px] xl:max-w-[240px]">
                      {stat.description}
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}

          <Card className="bg-[#F5F5F5] border-none w-full col-span-2 h-[100px] lg:h-[110px] xl:h-[120px] min-h-[100px]">
            <CardContent className="p-4 lg:p-[25px] h-full flex items-left">
              <div className="flex md:flex-row lg:flex-row xl:flex-row items-center gap-2 xl:gap-5 w-full">
                <div className="font-bold text-left text-primary text-[32px] lg:text-[42px] xl:text-[50px] leading-none whitespace-nowrap">
                  {statistics[2].value}
                </div>
                <div className="font-normal text-charcoal text-sm lg:text-base xl:text-xl leading-[1.5] text-left lg:text-left w-full">
                  {statistics[2].description}
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>

      {/* Target Audience Section */}
      <div className="w-full xl:w-[546px] mt-8 lg:mt-0">
        <Card className="bg-[#EDFFF2] border-none rounded-2xl w-full h-auto min-h-[320px]">
          <CardContent className="p-6 lg:p-[30px] h-full flex flex-col">
            <div>
              <h2 className="font-medium text-charcoal text-left text-2xl lg:text-[28px] leading-[1.5]">
                Who is this for?
              </h2>
              <p className=" w-full mt-2 text-left lg:mt-[10px] font-normal text-charcoal text-base lg:text-xl leading-[1.5]">
                If growing your sales is the goal, BuildMapper gives you the tools
                to make it happen — faster and smarter. We serve:
              </p>
            </div>

            <div className="flex flex-col gap-3 lg:gap-4 xl:gap-4 mt-6 xl:mt-[24px] flex-grow justify-center">
              {targetAudience.map((audience, index) => (
                <div key={index} className="flex items-start gap-2 break-words max-w-full">
                  <CheckIcon className="w-5 h-5 lg:w-6 lg:h-6 text-white mt-[2px] flex-shrink-0 bg-primary rounded-full" />
                  <span className="font-medium text-charcoal text-base lg:text-base xl:text-lg leading-[1.3]">
                    {audience}
                  </span>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};
